var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.95,47.91c-1.25,0-2.31-.43-3.18-1.3-.87-.87-1.3-1.93-1.3-3.18V15.24c0-1.25.43-2.31,1.3-3.18.87-.87,1.93-1.3,3.18-1.3h10.38v-4.19c0-1.25.43-2.31,1.3-3.18.87-.87,1.93-1.3,3.18-1.3h8.38c1.25,0,2.31.43,3.18,1.3.87.87,1.3,1.93,1.3,3.18v4.19h10.38c1.25,0,2.31.43,3.18,1.3.87.87,1.3,1.93,1.3,3.18v28.2c0,1.25-.43,2.31-1.3,3.18-.87.87-1.93,1.3-3.18,1.3H5.95ZM5.95,44.2h38.11c.19,0,.37-.08.52-.24.16-.16.24-.33.24-.52V15.24c0-.19-.08-.37-.24-.52-.16-.16-.33-.24-.52-.24H5.95c-.19,0-.37.08-.52.24-.16.16-.24.33-.24.52v28.2c0,.19.08.37.24.52.16.16.33.24.52.24ZM20.05,10.76h9.91v-4.19c0-.19-.08-.37-.24-.52-.16-.16-.33-.24-.52-.24h-8.38c-.19,0-.37.08-.52.24-.16.16-.24.33-.24.52v4.19ZM5.18,44.2V14.47v29.72ZM23.14,31.19v7.43h3.72v-7.43h7.43v-3.72h-7.43v-7.43h-3.72v7.43h-7.43v3.72h7.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspections);
export default __webpack_public_path__ + "static/media/inspections.a6ae6f7e473ec0ebb8715b264263c857.svg";
export { ForwardRef as ReactComponent };